import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { IAuthCommon } from './../store/auth.interfaces';
import { SearcherUserLogin, SearchRequest } from 'src/app/shared/models/searchers';

@Injectable({
    providedIn: 'root',
})
export class SearcherAuthService {
    constructor(private http: HttpClient) { }

    /**
     * Login in to Searcher
     * @param loginUser {LoginUser}
     * @returns Observable<IAuthCommon>
     */
    searcherLogin(loginUser: SearcherUserLogin): Observable<IAuthCommon> {
        return this.http
            .post<any>(`${environment.api.root}/${environment.api.searcher_login}`, {
                data: { userName: loginUser.userName, strataPlanNumber: loginUser.strataPlanNumber, password: loginUser.password },
            })
            .pipe(
                map((res) => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }


    /**
     * Request access to member site
     * @param requestAccess RequestAccess object
     */

    searchRequest(requestAccess: SearchRequest): Observable<string> {
        const formData = new FormData();
        formData.append('StrataPlanNumber', requestAccess.StrataPlanNumber);
        formData.append('CompanyName', requestAccess.CompanyName);
        formData.append('SearcherName', requestAccess.SearcherName);
        formData.append('Email', requestAccess.Email);
        formData.append('MobilePhone', requestAccess.MobilePhone);
        formData.append('Comments', requestAccess.Comments);
        formData.append('Attachment', requestAccess.Attachment);
        return this.http
            .post<any>(
                `${environment.api.root}/${environment.api.document_search}`,
                formData)
            .pipe(
                map((res) => res),
                catchError(this.handleError)
            );
    }


    private handleError(err) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        let errorMessage: string;
        if (err && err.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            errorMessage = `An error occurred: ${err.error.message}`;
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            errorMessage = `Backend returned code ${err.status}: ${err.code}`;
            if (err.error) {
                errorMessage = err.error;
            }
        }
        return throwError(errorMessage);
    }

}
